import Modal from "@mui/material/Modal";
import {kButtonStyles, kModalStyles} from "../../constants/styles";
import {kSystemIcons} from "../../constants/icons";
import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../buttons/SystemCustomButton";
import SystemScreenInfoHeader from "../headers/SystemScreenInfoHeader";

export default function SystemLeaveFlashDialog({ open,
                                                 handleClose,
                                                 leave }) {
    // Used in MetaFlashScreen to ask confirmation
    // about leaving current flash

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.neoDialogStyle}>
                {/** HEADER */}
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.exit}
                                        title={"Quitter le flash ?"} />


                {/*<div className={"w-full flex justify-between items-center border-b-[1px] border-greyLight3 p-[16px]"}>*/}
                {/*    <span className={"font-bold text-[18px] text-white"}>*/}
                {/*        {"Quitter le flash en cours ?"}*/}
                {/*    </span>*/}
                {/*    <div className={`cursor-pointer text-greyLight9 bg-backgroundLight4 hover:bg-backgroundLight5*/}
                {/*            w-[32px] min-w-[32px] h-[32px] min-h-[32px]*/}
                {/*            rounded-[8px] shadow-[inset_0_0_0_1px_#374356]*/}
                {/*            flex justify-center items-center`}*/}
                {/*         onClick={handleClose}>*/}
                {/*        <i className="material-icons text-[20px]">*/}
                {/*            {kSystemIcons.close}*/}
                {/*        </i>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/** CONTENT */}
                <div className={"w-full flex flex-col justify-start items-start px-[24px] pb-[24px] mt-[16px]"}>
                    <span className={"font-normal text-[16px] text-greyLight11"}>
                        {"Tu perdras toute ta progression et tu ne pourras pas consulter la correction des questions auxquelles tu as déjà répondu."}
                    </span>
                    <div className={"mt-[16px] w-full flex space-x-[16px]"}>
                        <SystemSecondaryCustomButton
                            label={"Annuler"}
                            isDisabled={false}
                            isLoading={false}
                            isFullWidth={true}
                            sizeStyle={kButtonStyles.mediumButtonStyle}
                            extraClass={"w-full"}
                            onButtonClick={handleClose} />
                        <SystemPrimaryCustomButton
                            label={"Quitter"}
                            isDisabled={false}
                            isLoading={false}
                            isFullWidth={true}
                            sizeStyle={kButtonStyles.mediumButtonStyle}
                            extraClass={"w-full"}
                            onButtonClick={leave} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}